<script lang="ts">
  import ActionButton from '../components/ActionButton.svelte';
  import Modal from '../components/Modal.svelte';
  import Close from '~icons/mdi/close';
  import Send from '~icons/mdi/send';
  import { submitScoreMutation } from './queries.svelte';
  import Spinner from '../components/Spinner.svelte';
  import { getEntry } from '~/lib/mutations.svelte';
  import { ModalState } from '~/lib/nav.svelte';
  import { leaderboardModal } from './LeaderboardModal.svelte';
  import AwardIcon from '~/icons/AwardIcon.svelte';
  import StatusText from '~/components/StatusText.svelte';
  import type { ClassicGame } from '~/store/classic.svelte';
  import { playerName } from '~/auth/utils.svelte';

  type Props = { game: ClassicGame };
  const props: Props = $props();
  const submitScore = submitScoreMutation();
  const postScoreModal = new ModalState('postScore');

  let error = $state<string>();

  const handleOpenLeaderboard = () => {
    leaderboardModal.replace();
  };

  const handleOpen = () => {
    postScoreModal.push();
  };

  const handleClose = () => {
    postScoreModal.pop();
  };

  const handleSubmit = async (e: Event) => {
    e.preventDefault();
    if (submitScore.isIdle) {
      try {
        await submitScore.mutateAsync(await getEntry(props.game, playerName.current));
        handleOpenLeaderboard();
      } catch (err) {
        if (
          typeof err === 'object' &&
          err !== null &&
          'code' in err &&
          err.code === '23505'
        ) {
          error = 'already submitted!';
        }
      }
    }
  };
</script>

{#if submitScore.isIdle}
  <ActionButton onClick={handleOpen}>
    <AwardIcon />
    Post Score
  </ActionButton>
{:else}
  <ActionButton onClick={handleOpenLeaderboard}>
    <AwardIcon />
    Leaderboard
  </ActionButton>
{/if}
<Modal index={3} open={postScoreModal.open} onClose={handleClose}>
  {#snippet title()}
    Post Your Score
  {/snippet}
  {#snippet content()}
    <form name="submit-score" onsubmit={handleSubmit}>
      {#if error}
        <StatusText status="warn">{error}</StatusText>
      {:else if submitScore.isPending}
        <Spinner />
      {:else}
        <p>Show off your word skills and see how you stack up!</p>
        <input
          type="text"
          placeholder="name"
          bind:value={playerName.current}
          required
        />
      {/if}
    </form>
  {/snippet}
  {#snippet controls()}
    <ActionButton onClick={handleClose}>
      <Close />
      Close
    </ActionButton>
    <ActionButton onClick={handleSubmit} disabled={submitScore.isPending}>
      <Send />
      {#if submitScore.isPending}
        Submitting...
      {:else}
        Submit
      {/if}
    </ActionButton>
  {/snippet}
</Modal>

<style>
  p {
    margin-top: 0;
    text-align: center;
  }
  input {
    width: 100%;
    max-width: 24em;
  }
</style>
